import React from "react";

const ReservationCountNormalization = ({ row }) => {
  return (
    <div>
      {row?.reservationsCount ? row?.reservationsCount?.toLocaleString() : 0}
    </div>
  );
};

export default ReservationCountNormalization;
